import {
  axiosApiInstance,
  axiosStorageInstance,
  axiosPrinterInstance,
} from "../axios";

export async function makePostApiCall(
  endPoint,
  payload,
  contentType = "application/json"
) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
      "content-type": contentType,
    },
  };

  const user_id = localStorage.getItem("id") * 1;
  const user_name = localStorage.getItem("name");

  let requestPayload = payload;
  if (payload instanceof FormData) {
    requestPayload = payload;
    delete config.headers["content-type"];
  } else {
    requestPayload = {
      ...payload,
      user_id: user_id,
      user_name: user_name,
    };
  }

  return axiosApiInstance
    .post(endPoint, requestPayload, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch((err) => {
    if (!err){
        return  {data: {
          title: "Error",
          subtitle: "We could not complete the action.",
          errorStatus: 500,
        },
      }
    }

    if (!err.response){
        return  {data: {
          title: "Error",
          message: "We could not complete the action.",
          errorStatus: 500,
        },
      }
    }

      const emptyData = {
        data: {
          title: "Error",
          message: "We could not complete the action.",
          errorStatus: err.response.status,
        },
      };

      if (err.response) {
        if (err.response.data) {
          return {
            success: false,
            data: err.response.data,
            errorStatus: err.response.status,
          };
        }
        return emptyData;
      } else {
        return {
          success: false,
          data: emptyData,
          errorStatus: err.response.status,
        };
      }
    });
}

export async function makePutApiCall(endPoint, payload, contentType) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
      "content-type": contentType ? contentType : "application/json",
    },
  };

  const user_id = localStorage.getItem("id") * 1;
  const user_name = localStorage.getItem("name");

  let requestPayload = payload;
  if (payload instanceof FormData) {
    requestPayload = payload;
    delete config.headers["content-type"];
  } else {
    requestPayload = {
      ...payload,
      user_id: user_id,
      user_name: user_name,
    };
  }

  return axiosApiInstance
    .put(endPoint, requestPayload, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch((err) => {
      const emptyData = {
        data: {
          title: "Error",
          subtitle: "We could not complete the action.",
          errorStatus: err.response.status,
        },
      };

      if (err.response) {
        if (err.response.data) {
          return {
            success: false,
            data: err.response.data,
            errorStatus: err.response.status,
          };
        }
        return emptyData;
      } else {
        return {
          success: false,
          data: emptyData,
          errorStatus: err.response.status,
        };
      }
    });
}

export async function makeGetApiCall(endPoint) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  return axiosApiInstance
    .get(endPoint, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch((err) => {
      const emptyData = {
        data: {
          title: "Error",
          subtitle: "We could not complete the action.",
          errorStatus: err.response.status,
        },
      };

      if (err.response) {
        if (err.response.data) {
          return {
            success: false,
            data: err.response.data,
            errorStatus: err.response.status,
          };
        }
        return emptyData;
      } else {
        return {
          success: false,
          data: emptyData,
          errorStatus: err.response.status,
        };
      }
    });
}

export async function makeDeleteApiCall(endPoint) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  return axiosApiInstance
    .delete(endPoint, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch((err) => {
      const emptyData = {
        data: {
          title: "Error",
          subtitle: "We could not complete the action.",
          errorStatus: err.response?.status,
        },
      };

      if (err.response) {
        if (err.response.data) {
          return {
            success: false,
            data: err.response.data,
            errorStatus: err.response.status,
          };
        }
        return emptyData;
      } else {
        return {
          success: false,
          data: emptyData.data,
          errorStatus: 500,
        };
      }
    });
}

export async function makeGetCall(endPoint) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  return axiosStorageInstance
    .get(endPoint, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch((err) => {
      const emptyData = {
        data: {
          title: "Error",
          subtitle: "We could not complete the action.",
          errorStatus: err.response.status,
        },
      };

      if (err.response) {
        if (err.response.data) {
          return {
            success: false,
            data: err.response.data,
            errorStatus: err.response.status,
          };
        }
        return emptyData;
      } else {
        return {
          success: false,
          data: emptyData,
          errorStatus: err.response.status,
        };
      }
    });
}

export async function makePostApiCallToPrinter(payload) {
  const config = {};

  const user_id = localStorage.getItem("id") * 1;
  const user_name = localStorage.getItem("name");

  const newPayload = {
    ...payload,
    user_id: user_id,
    user_name: user_name,
  };

  return axiosPrinterInstance
    .post("/print-label", newPayload, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch((err) => {
      if (err.response) {
        if (err.response.data) {
          return {
            success: false,
            data: err.response.data,
            errorStatus: err.response.status,
          };
        }
        return {
          success: false,
          data: {
            title: "Error",
            subtitle: "We could not complete the action.",
            message: "We could not complete the action.",
          },
          errorStatus: err.response.status,
        };
      }

      return {
        success: false,
        data: {
          title: "Error",
          subtitle: "Printer service is unavailable.",
          message: "Printer service is unavailable.",
        },
        errorStatus: null,
      };
    });
}

// POST request expecting a binary/blob response (e.g. file download)
export async function makePostApiCallBlob(endPoint, payload) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
      "content-type": "application/json",
    },
    responseType: "blob",
  };

  const user_id = localStorage.getItem("id") * 1;
  const user_name = localStorage.getItem("name");

  const newPayload = {
    ...payload,
    user_id: user_id,
    user_name: user_name,
  };

  return axiosApiInstance
    .post(endPoint, newPayload, config)
    .then((response) => {
      // response.data is a blob
      return {
        success: true,
        data: response.data,
        headers: response.headers,
      };
    })
    .catch(async (err) => {
      // Try to extract status when available
      const status =
        err && err.response && err.response.status ? err.response.status : null;

      let errorData = null;
      const responseData = err?.response?.data;
      if (responseData instanceof Blob) {
        try {
          errorData = JSON.parse(await responseData.text());
        } catch (_parseError) {
          errorData = null;
        }
      }

      return {
        success: false,
        data: errorData || {
          title: "Error",
          subtitle: "We could not complete the download.",
          message: "We could not complete the download.",
        },
        errorStatus: status,
      };
    });
}
